// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { MapScriptFormData, MapScriptFormDataT } from '../tbs/map-script-form-data.js';


export class MapScriptFormDataEnvelope implements flatbuffers.IUnpackableObject<MapScriptFormDataEnvelopeT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):MapScriptFormDataEnvelope {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsMapScriptFormDataEnvelope(bb:flatbuffers.ByteBuffer, obj?:MapScriptFormDataEnvelope):MapScriptFormDataEnvelope {
  return (obj || new MapScriptFormDataEnvelope()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsMapScriptFormDataEnvelope(bb:flatbuffers.ByteBuffer, obj?:MapScriptFormDataEnvelope):MapScriptFormDataEnvelope {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new MapScriptFormDataEnvelope()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

data(obj?:MapScriptFormData):MapScriptFormData|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new MapScriptFormData()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startMapScriptFormDataEnvelope(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addData(builder:flatbuffers.Builder, dataOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, dataOffset, 0);
}

static endMapScriptFormDataEnvelope(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createMapScriptFormDataEnvelope(builder:flatbuffers.Builder, dataOffset:flatbuffers.Offset):flatbuffers.Offset {
  MapScriptFormDataEnvelope.startMapScriptFormDataEnvelope(builder);
  MapScriptFormDataEnvelope.addData(builder, dataOffset);
  return MapScriptFormDataEnvelope.endMapScriptFormDataEnvelope(builder);
}

unpack(): MapScriptFormDataEnvelopeT {
  return new MapScriptFormDataEnvelopeT(
    (this.data() !== null ? this.data()!.unpack() : null)
  );
}


unpackTo(_o: MapScriptFormDataEnvelopeT): void {
  _o.data = (this.data() !== null ? this.data()!.unpack() : null);
}
}

export class MapScriptFormDataEnvelopeT implements flatbuffers.IGeneratedObject {
constructor(
  public data: MapScriptFormDataT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const data = (this.data !== null ? this.data!.pack(builder) : 0);

  return MapScriptFormDataEnvelope.createMapScriptFormDataEnvelope(builder,
    data
  );
}
}
